import React, { useRef, useEffect, useState } from 'react';
import ExperienceItem from './ExperienceItem';
import { useT } from '../context/LanguageContext';

function useInView(threshold = 0.15) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setInView(true); },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, inView];
}

const Work = () => {
  const { t } = useT();
  const [headerRef, headerInView] = useInView(0.2);

  return (
    <section className="w-full bg-black py-16 sm:py-24">
      <div className="px-[6%] sm:px-[8%] lg:px-[10%]">

        <div
          ref={headerRef}
          className="mb-14 sm:mb-20 text-center"
          style={{
            opacity: headerInView ? 1 : 0,
            transform: headerInView ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.6s ease, transform 0.6s ease',
          }}
        >
          <p className="text-xs text-zinc-600 uppercase tracking-[0.2em] mb-3">{t.work.sectionLabel}</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-white tracking-tight">
            {t.work.title}
          </h2>
          <div
            className="mt-3 h-px bg-yellow-300 mx-auto"
            style={{
              width: headerInView ? '2rem' : '0',
              transition: 'width 0.6s ease 0.3s',
            }}
          />
        </div>

        <div className="flex flex-col">
          {t.work.experience.map((exp, index) => (
            <ExperienceItem
              key={index}
              {...exp}
              index={index}
              isLast={index === t.work.experience.length - 1}
              labels={{
                responsibilities: t.work.responsibilities,
                techStack: t.work.techStack,
                expand: t.work.expand,
                collapse: t.work.collapse,
              }}
            />
          ))}
        </div>

      </div>
    </section>
  );
};

export default Work;
